let init = null;

export default function siteData(state = init, action) {
  switch (action.type) {
    case "SET_DATA": 
      state = { 
        categoryList: action.payload.categoryList, 
        itemsList: action.payload.itemsList
      }
      return state;

    default:
      return state
  }
}